module.exports = __webpack_public_path__ + "static/media/img_bg2.05dd924b.jpg";